import type { AgentModeKey } from '@developerz/domain';
import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { useAgentModes } from '../lib/agent-modes';
import { UNSET } from '../lib/unset';
import { StatusPill } from './StatusPill';

// One repo's READ-ONLY mode row, inside the Advanced drawer's Per-repo section
// (#5211 AC3: "repo mode overrides render with no enabled control"). Mode
// overrides are edited from the repo's own Settings tab (`AgentModesPanel`,
// `scope={{kind:'repo', repoId}}`) — this drawer only ever SHOWS which source
// won (repo / org / default) so a maintainer is not surprised by a mode
// resolving differently for one repo. Mounted only when the caller holds
// `write:prompts` — the parent gates that, the same way it gates the org read.

export function AgentRepoModeRow(props: {
  readonly repoId: string;
  readonly modeKey: AgentModeKey;
  readonly token: string | null;
}): JSX.Element {
  const modes = useAgentModes(() => ({ kind: 'repo', repoId: props.repoId }), props.token);
  const view = () => modes.data?.find((v) => v.key === props.modeKey);

  return (
    <p class="agent-drawer__repo-mode">
      <Show when={view()} fallback={<span class="agent-drawer__repo-mode-loading">{UNSET}</span>}>
        {(v) => (
          <>
            <StatusPill tone={v().enabled ? 'success' : 'neutral'}>
              {v().enabled ? t('agent_modes.on') : t('agent_modes.off')}
            </StatusPill>
            <span class="agent-drawer__repo-mode-source">
              {t(`agent_modes.source.${v().source}`)}
            </span>
          </>
        )}
      </Show>
    </p>
  );
}
